import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPersonalizedProducts } from "./personalizedProducts.service";
import { PersonalizedProductGroup } from "./personalizedProducts.types";

export const getPersonalizedProducts = createAsyncThunk<
  PersonalizedProductGroup[],
  void,
  { rejectValue: string }
>("personalizedProducts/get", async (_, { rejectWithValue }) => {
  try {
    const res = await fetchPersonalizedProducts();
    if (!res.status) return rejectWithValue("Kişiselleştirilmiş ürünler yüklenemedi.");
    return res.data;
  } catch {
    return rejectWithValue("Kişiselleştirilmiş ürünler yüklenemedi.");
  }
});